var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"grey lighten-1",attrs:{"id":"mainContent","fluid":"","fill-height":"","pa-0":""}},[_c('main-header'),_c('main-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }